// import mixins from './../_mixins-missmatch-monitor';
import methods from './_methods';
import mounted from './_mounted';

export default {
    name: 'TableOperationsMismatch',
    mounted,
    methods,
    watch: {
        // Watcher para comprobar si se ha seleccionado un radiobutton o no
        // y así marcar la fila como seleccionada en el array de items.
        selected() {
            const value = this.selected;
            const indexSelected = value.split('product__row__');
            this.itemsFormated.forEach(el => (el.selected = false));
            this.itemsFormated[indexSelected[1]].selected = true;
            this.$root.$emit('productSelected', this.itemsFormated[indexSelected[1]].productName);
        }
    },
    data() {
        return {
            loading: true,
            lastOperations: []
        };
    },
    props: {
        accountId: {
            type: String,
            required: true
        },
        account: {
            type: String,
            required: true
        },
        productSelected: {
            type: Object,
            required: true
        },
        checksActivated: {
            type: Boolean
        }
    },
    computed: {
        // Formateamos los datos recibidos desde el componente padre
        itemsFormated() {
            return this.items.map(x => {
                return {
                    uuid: x.uuid,
                    uuid_mismatched_operation: x.uuid,
                    uuid_daily_summmary: x.uuid_daily_summmary,
                    id_object: x.rd_operation.id_object,
                    operation_date: x.rd_operation.operation_date,
                    nav: x.rd_operation.nav,
                    key_product: x.rd_operation.key_product,
                    key_operation_type: x.rd_operation.key_operation_type,
                    shares: x.rd_operation.shares,
                    gross_amount: x.rd_operation.gross_amount,
                    withholding: x.rd_operation.withholding,
                    commission: x.rd_operation.commission,
                    net_amount: x.rd_operation.net_amount,
                    show_details: true,
                    yuri_operation: { ...x.yuri_operation },
                    rd_operation: { ...x.rd_operation },
                    actionData: {
                        match: true,
                        uuid: x.uuid_account ? x.uuid_account : null,
                        uuid_daily_summary: x.uuid_daily_summmary || null,
                        uuid_mismatched_operation: x.uuid || null,
                        ...x.rd_operation,
                        uuid_account: x.uuid_account
                    }
                };
            });
        },
        // Columnas que queremos mostrar en la tabla
        fields() {
            return [
                'id_object',
                'operation_date',
                'key_product',
                'key_operation_type',
                'shares',
                'nav',
                'withholding',
                'commission',
                'gross_amount',
                'net_amount',
                'show_details'
            ];
        },
        fieldsSubtable() {
            return ['shares', 'nav', 'withholding', 'commission', 'gross_amount', 'net_amount', 'show_details'];
        }
    }
};
